import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Mock Portfolio Data using Unsplash
const portfolioData = [
  { id: 1, category: 'Blackwork', img: 'https://images.unsplash.com/photo-1598371839696-5c5bb00bdc28?auto=format&fit=crop&q=80&w=600' },
  { id: 2, category: 'Fine Line', img: 'https://images.unsplash.com/photo-1647125261179-a60e46a7f172?auto=format&fit=crop&q=80&w=600' },
  { id: 3, category: 'Realism', img: 'https://plus.unsplash.com/premium_photo-1769810612875-423d01e867f7?auto=format&fit=crop&q=80&w=600' },
  { id: 4, category: 'Traditional', img: 'https://plus.unsplash.com/premium_photo-1679931608155-9a26a9dccd6a?auto=format&fit=crop&q=80&w=600' },
  { id: 5, category: 'Blackwork', img: 'https://images.unsplash.com/photo-1627960630431-270d04164a22?auto=format&fit=crop&q=80&w=600' },
  { id: 6, category: 'Realism', img: 'https://images.unsplash.com/photo-1695226304152-931956f4a474?auto=format&fit=crop&q=80&w=600' },
  { id: 7, category: 'Fine Line', img: 'https://images.unsplash.com/photo-1570168983832-8989dae1522e?auto=format&fit=crop&q=80&w=600' },
  { id: 8, category: 'Large Project', img: 'https://plus.unsplash.com/premium_photo-1707761864662-eeeb7d09b712?auto=format&fit=crop&q=80&w=600' },
  { id: 9, category: 'Traditional', img: 'https://plus.unsplash.com/premium_photo-1707057704991-1f0cec6e9a3f?auto=format&fit=crop&q=80&w=600' },
];

const categories = ['All', 'Blackwork', 'Fine Line', 'Realism', 'Traditional', 'Large Project'];

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [selectedImg, setSelectedImg] = useState(null);

  const filteredPortfolio = activeFilter === 'All' 
    ? portfolioData 
    : portfolioData.filter(item => item.category === activeFilter);

  return (
    <div className="pt-24 pb-20 bg-background min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-6xl font-display mb-6">Portfolio</h1>
          <div className="w-20 h-1 bg-secondary mx-auto mb-8"></div>
          
          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setActiveFilter(cat)}
                className={`px-6 py-2 text-sm uppercase tracking-wider transition-all duration-300 ${
                  activeFilter === cat 
                    ? 'bg-secondary text-primary' 
                    : 'bg-primary text-light hover:bg-gray-800'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </motion.div>

        {/* Gallery Grid */}
        <motion.div 
          layout
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"
        >
          <AnimatePresence>
            {filteredPortfolio.map((item) => (
              <motion.div
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                key={item.id}
                className="aspect-square relative group overflow-hidden cursor-pointer"
                onClick={() => setSelectedImg(item.img)}
              >
                <img 
                  src={item.img} 
                  alt={item.category} 
                  className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-primary/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <span className="text-light font-display text-lg tracking-widest uppercase border border-light px-4 py-2">
                    {item.category}
                  </span>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImg && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4 cursor-pointer"
            onClick={() => setSelectedImg(null)}
          >
            <motion.img 
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              src={selectedImg} 
              alt="Enlarged portfolio piece" 
              className="max-h-[90vh] max-w-full object-contain"
            />
            <button className="absolute top-6 right-6 text-light text-xl p-4">Close (X)</button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Portfolio;